var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserMain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    width: 78,
    height: 78,
    rx: 15,
    fill: "#4A86F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 57.3327H51.8333C52.8058 57.3327 53.7384 56.9464 54.4261 56.2587C55.1137 55.5711 55.5 54.6385 55.5 53.666V24.3327C55.5 23.3602 55.1137 22.4276 54.4261 21.74C53.7384 21.0523 52.8058 20.666 51.8333 20.666H26.1667C25.1942 20.666 24.2616 21.0523 23.5739 21.74C22.8863 22.4276 22.5 23.3602 22.5 24.3327V53.666C22.5 54.6385 22.8863 55.5711 23.5739 56.2587C24.2616 56.9464 25.1942 57.3327 26.1667 57.3327H28ZM39 26.1642C42.0195 26.1642 44.5 28.641 44.5 31.6642C44.5 34.6855 42.0195 37.166 39 37.166C35.9805 37.166 33.5 34.6855 33.5 31.6642C33.5 28.641 35.9805 26.1642 39 26.1642ZM28 48.6243C28 44.5562 32.9592 40.3743 39 40.3743C45.0408 40.3743 50 44.5562 50 48.6243V49.9993H28V48.6243Z",
    fill: "#4A86F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserMain);
export default __webpack_public_path__ + "static/media/userMain.e4af014ba9cdc83a3b7b5f0cc42e9b0a.svg";
export { ForwardRef as ReactComponent };